import 'jquery';
import '../components/sitenav';

export default {
  init() {
    // JavaScript to be fired on all pages

    // JavaScript to be fired on the home page, after the init JS
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    var hash = window.location.hash;

    if(hash && hash.indexOf(',') == -1) {
      var new_hash = decodeURIComponent(hash).replace('#', '#collapse-');
      var $hash_el = $( new_hash );

      if( $hash_el.length ) {
        $( $hash_el ).addClass('in show');
  
        $('html, body').animate({
          scrollTop: $hash_el.offset().top + 'px',
        }, 'fast');
      }
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js